// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"cd9320c61439610d7fac","223":"af1ef5ba27940e472a00","293":"6e2ed5c6448c21614740","522":"4e98084ca66a1fee15dc"}[chunkId] + ".js";
};